export default "__VITE_ASSET__24ad22e6__"